module.exports = __webpack_public_path__ + "static/media/upload.3c9b5f02.png";